import { toast } from "react-toastify";
import { convertRawData, convertToRawData } from "./automationEngineUtils";
import { getUrl } from "./urls";
import axios from "axios";
import { getAccessToken, getCompanyId } from "./utils";
import store from "../store";

export const ADD_NEW_NODES = "ADD_NEW_NODES";
export const CONFIRM_DELETE = "CONFIRM_DELETE";
export const DELETE_NODES = "DELETE_NODES";
export const TOGGLE_DROPDOWN = "TOGGLE_DROPDOWN";

export const SET_NAME_AND_DESCRIPTION = "SET_NAME_AND_DESCRIPTION";

export const TRIGGER_NEW_NODE_ACTION = "TRIGGER_NEW_NODE_ACTION";
export const EDIT_NODE_ACTION = "EDIT_NODE_ACTION";
export const UPDATE_NODE_ACTION = "UPDATE_NODE_ACTION";

export const CREATE_NEW_RULE = "CREATE_NEW_RULE";
export const CLEAN_UP_DATA = "CLEAN_UP_DATA";
export const FETCH_AUTOMATION_RULES = "FETCH_AUTOMATION_RULES";
export const TOGGLE_ACTIVE_STATUS = "TOGGLE_ACTIVE_STATUS";
export const EDIT_RULE = "EDIT_RULE";

export const automationRulesList = () => {
    const res = axios
        .get(getUrl("rule_engine"), {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "access-token": getAccessToken(),
            },
        })
        .then((response) => {
            // console.log("response.data", response.data?.data?.rules);

            // const rules = response.data?.data?.rules?.map((rule) => {
            //     console.log("rulesss", rule);
            //     const { nodes, edges } = convertRawData(JSON.parse(rule.rule_data));

            //     return { ...rule, nodes, edges };
            // });
            // console.log("ruleeee", rules);

            return response.data;
        })
        .catch((err) => {
            toast.error(err.response.data?.message);
            throw err;
        });

    return {
        type: FETCH_AUTOMATION_RULES,
        payload: res,
    };
};

export const addNewNodes = (payload) => {
    return {
        type: ADD_NEW_NODES,
        payload,
    };
};
export const deleteNodes = (payload) => {
    return {
        type: DELETE_NODES,
        payload,
    };
};

export const confirmDeleteNodes = (payload = {}) => {
    return {
        type: CONFIRM_DELETE,
        payload,
    };
};

export const toggleDropdown = (payload = {}) => {
    return {
        type: TOGGLE_DROPDOWN,
        payload,
    };
};
export const triggerNewNodeAction = (payload = {}) => {
    return {
        type: TRIGGER_NEW_NODE_ACTION,
        payload,
    };
};
export const editNodeAction = (payload = {}) => ({ type: EDIT_NODE_ACTION, payload });
export const updateNodeActionEvents = (payload) => ({ type: UPDATE_NODE_ACTION, payload });

export const createNewRule = ({ params, updateRule }) => {
    return async (dispatch) => {
        const nodes = store.getState().automationEngineReducer.nodes;
        const edges = store.getState().automationEngineReducer.edges;
        const method = updateRule ? "patch" : "post";
        const url = updateRule ? `${getUrl("rule_engine")}/${updateRule}` : `${getUrl("rule_engine")}`;

        dispatch({
            type: "CREATE_NEW_RULE_PENDING",
        });

        const { formattedNodes, formattedEdges } = convertToRawData({ nodes, edges });
        // params["edges"] = edges;
        params["rule_data"] = formattedNodes;
        params.rule_data.edges = edges;

        try {
            await axios({
                method,
                url,
                headers: {
                    "Content-Type": "application/json",
                    "access-token": getAccessToken(),
                    cache: false,
                },
                data: params,
            });
            dispatch({
                type: "CREATE_NEW_RULE_FULFILLED",
            });
            updateRule ? toast.success("Rule updated successfully") : toast.success("Rule created successfully");
            return { success: 200 };
        } catch (error) {
            updateRule ? toast.error("Failed to update the Rule") : toast.error("Failed to create a Rule");
            console.log(error);
            dispatch({
                type: "CREATE_NEW_RULE_REJECTED",
            });
            return { error };
        }
    };
};
export const ruleEngineCleanup = () => ({ type: CLEAN_UP_DATA });

export const editRule = (rule) => {
    const { nodes, edges } = convertRawData(JSON.parse(rule.rule_data));
    // const { nodes, edges } = rule;

    return {
        type: EDIT_RULE,
        payload: {
            nodes,
            edges,
            automationName: rule.name,
            automationDescription: rule.description,
            ruleId: rule.id,
        },
    };
};
export const ruleEngineDescription = (payload) => ({ type: SET_NAME_AND_DESCRIPTION, payload });

export const deleteRule = async ({ params, ruleId }) => {
    try {
        await axios.delete(`${getUrl("rule_engine")}/${ruleId}`, {
            data: params,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        toast.success("Rule deleted successfully");
    } catch (error) {
        toast.error("Failed to delete the rule");
    }
};
export const toggleRuleStatus = async (params, ruleId) => {
    try {
        const response = await axios({
            method: "patch",
            url: `${getUrl("rule_engine")}/${ruleId}`,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
                cache: false,
            },
            data: params,
        });

        if (response.statusText === "OK") {
            toast.success(`Rule ${params.is_active === 1 ? "activated" : "deactivated"} successfully`);

            return true;
        }
    } catch (error) {
        console.log(error);
        return false;
    }
};

export const toggleMasterRuleEngine = async (data) => {
    try {
        const response = await axios({
            method: "patch",
            url: `${getUrl("company_service")}/${getCompanyId()}`,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
                cache: false,
            },
            data,
        });

        if (response.statusText === "OK") {
            toast.success(`Automation Engine ${data.automation_engine_enabled === 1 ? "enabled" : "disabled"} successfully`);

            return true;
        }
    } catch (error) {
        toast.error(error.response?.data?.message);

        console.log(error);
        return false;
    }
};
export const updateRulePriorities = async ({ params, ruleId }) => {
    try {
        await axios({
            method: "patch",
            url: `${getUrl("rule_engine")}/${ruleId}`,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
                cache: false,
            },
            data: params,
        });
        toast.success("Rule Priorities updated successfully");
    } catch (error) {
        console.log(error);
        toast.error(error.response?.data?.message);
    }
};
